import React from "react"
import { Button } from "antd"
import Modal from "./DraggableModal"   // s74 (tog'a 2026-09-09): barcha modal oynalar suriladi
import style from "./NewMadalR.module.css"
import { DatePicker, Space, Input } from "antd"
import { Select } from "antd"
import "./RMadalNew.css"
import i18n from "../../services/i18n"
const { Option } = Select
export const NewMadalR = () => {
  const [visible, setVisible] = React.useState(false)
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const showModal = () => {
    setVisible(true)
  }
  const handleOk = () => {
    setConfirmLoading(true)
    setTimeout(() => {
      setVisible(false)
      setConfirmLoading(false)
    }, 2000)
  }
  const handleCancel = () => {
    setVisible(false)
  }
  return (
    <div className={style.Wrapper}>
      <Modal
        visible={visible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        className={style.Madal}
      >
        <h1 className={style.Title}>{i18n.t("addPurchase")}</h1>
        {/* <p>{modalText}</p> */}
        <div className={style.WrapperBlock1}>
          <Space direction="vertical" className={style.WrapperBlock2}>
            <div className={style.Block}>
              <div className={style.BlockInput}>
                {" "}
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong> Дата закупки
                </label>
                <br />
                <DatePicker className={style.Input1} />
              </div>
              <div className={style.BlockInput}>
                {" "}
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong> Завод
                </label>
                <br />
                <Input className={style.Input1} />
              </div>
              <div className={style.BlockInput}>
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong> Курс доллара
                </label>
                <br />

                <Input className={style.Input2} />
              </div>
            </div>
            <div className={style.Block}>
              <div className={style.BlockInput}>
                {" "}
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong>Склад
                </label>
                <br />
                <Select
                  className={style.Input1}
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                >
                  <Option value="1">Not Identified</Option>
                  <Option value="2">Closed</Option>
                  <Option value="3">Communicated</Option>
                  <Option value="4">Identified</Option>
                  <Option value="5">Resolved</Option>
                  <Option value="6">Cancelled</Option>
                </Select>
              </div>
              <div className={style.BlockInput}>
                {" "}
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong> Цена y.e
                </label>
                <br />
                <Input className={style.Input1} />
              </div>
              <div className={style.BlockInput}>
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong> Завод
                </label>
                <br />

                <Input className={style.Input1} />
              </div>
            </div>
            <div className={style.CustomsClearance}>
              <p>{i18n.t("customsClearance")}</p>
              <p>300$</p>
            </div>
            <div className={style.CustomsClearance}>
              <p>{i18n.t("customsClearance")}</p>
              <p>300$</p>
            </div>
            <div className={style.Block}>
              <div className={style.Expenses}>
                {" "}
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong>Расходы
                </label>
                <br />
                <Select
                  className={style.Input3}
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                >
                  <Option value="1">Not Identified</Option>
                  <Option value="2">Closed</Option>
                  <Option value="3">Communicated</Option>
                  <Option value="4">Identified</Option>
                  <Option value="5">Resolved</Option>
                  <Option value="6">Cancelled</Option>
                </Select>
              </div>
              <div className={style.Price}>
                {" "}
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong> Цена y.e
                </label>
                <br />
                <Input className={style.Input4} />
              </div>
              <div className={style.Buttons}>
                <Button className={style.button}>-</Button>
                <Button className={style.button}>+</Button>
              </div>
            </div>
            <div className={style.CustomsClearance}>
              <p>1. Samsung Galaxy a 22 S</p>
              <p>300$</p>
            </div>
            <div className={style.CustomsClearance}>
              <p>1. Samsung Galaxy a 22 S</p>
              <p>300$</p>
            </div>
            <div className={style.Block}>
              <div style={{ width: "70%" }}>
                {" "}
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong>Товар
                </label>
                <br />
                <Select
                  className={style.Input3}
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                >
                  <Option value="1">Not Identified</Option>
                  <Option value="2">Closed</Option>
                  <Option value="3">Communicated</Option>
                  <Option value="4">Identified</Option>
                  <Option value="5">Resolved</Option>
                  <Option value="6">Cancelled</Option>
                </Select>
              </div>
              <div style={{ width: "30%" }}>
                {" "}
                <label>
                  <strong style={{ color: "#FF0000" }}>*</strong> Количество
                </label>
                <br />
                <Input className={style.Input4} />
              </div>
              <div className={style.Buttons}>
                <Button className={style.button}>-</Button>
                <Button className={style.button}>+</Button>
              </div>
            </div>
            <div className={style.ButtonCalculation}>
              <button className={style.Calculation}>{i18n.t("calculateBtn")}</button>
            </div>
            <div className={style.ButtonCalculation}>
              <button className={style.Calculation}>{i18n.t("save")}</button>
            </div>
          </Space>
        </div>
      </Modal>
      <Button type="primary" onClick={showModal}>
        Modal 1
      </Button>
    </div>
  )
}
